
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M10.997 8.747v3.68c.002.352.188.678.49.86l3.12 1.85a.758.758 0 001.03-.26.749.749 0 00-.26-1.03l-2.87-1.71v-3.4a.769.769 0 00-.76-.74.755.755 0 00-.75.75zm10 .75v-5.29a.5.5 0 00-.85-.35l-1.78 1.78a9 9 0 102.56 7.48 1 1 0 00-1-1.12.984.984 0 00-.98.86 7.015 7.015 0 01-7.05 6.14 7.1 7.1 0 01-6.9-6.9 7 7 0 0111.95-5.05l-2.09 2.09a.5.5 0 00.35.86h5.29a.5.5 0 00.5-.5z","opacity":".75"}})])
          )
        }
      }
    